import {logger} from 'common'

import {
  CHAT_ACTIVE_WINDOW_MS,
  CHAT_LAST_MESSAGE_STORAGE_KEY,
  CHAT_LEFT_OPEN_STORAGE_KEY,
  MISSIVE_CHAT_ID,
} from './constants'

declare global {
  interface Window {
    MissiveChat: any
    MissiveChatConfig: any
    Missive: any
  }
}

// The one answer to "is the chat in the corner here", so the chat and the cookie banner's room
// for it cannot disagree.
export const isMissiveChatShown = (pathname: string): boolean =>
  Boolean(MISSIVE_CHAT_ID) &&
  pathname !== '/admin' &&
  !pathname.includes('/application-draft/') &&
  !pathname.includes('/office-action/') &&
  !pathname.includes('/portal') &&
  !pathname.includes('/use-in-commerce-request')

export const identifyMissiveUser = (
  name: string | undefined,
  email: string | undefined,
  missiveDigest: string | undefined,
) => {
  if (typeof window !== 'undefined') {
    window.MissiveChat?.setUser({
      name,
      email,
      digest: missiveDigest,
    })
  }
}

export const hasActiveMissiveChat = (): boolean => {
  try {
    const stored = window.localStorage.getItem(CHAT_LAST_MESSAGE_STORAGE_KEY)

    if (!stored) {
      return false
    }

    const lastMessage = Number(stored)

    if (Number.isFinite(lastMessage) && Date.now() - lastMessage < CHAT_ACTIVE_WINDOW_MS) {
      return true
    }

    // Expired, or unparseable - either way it is never going to be current again, so it goes
    // rather than being re-read on every page for the life of the browser profile.
    window.localStorage.removeItem(CHAT_LAST_MESSAGE_STORAGE_KEY)
    return false
  } catch (e) {
    // Private mode and blocked storage both throw on access; a visitor we cannot recognise just
    // gets the on-demand launcher.
    logger.warn(e)
    return false
  }
}

export const markMissiveChatActivity = () => {
  try {
    window.localStorage.setItem(CHAT_LAST_MESSAGE_STORAGE_KEY, String(Date.now()))
  } catch (e) {
    logger.warn(e)
  }
}

export const isMissiveChatLeftOpen = (): boolean => {
  try {
    return window.localStorage.getItem(CHAT_LEFT_OPEN_STORAGE_KEY) === 'true'
  } catch (e) {
    logger.warn(e)
    return false
  }
}

export const setMissiveChatLeftOpen = (open: boolean) => {
  try {
    if (open) {
      window.localStorage.setItem(CHAT_LEFT_OPEN_STORAGE_KEY, 'true')
    } else {
      window.localStorage.removeItem(CHAT_LEFT_OPEN_STORAGE_KEY)
    }
  } catch (e) {
    logger.warn(e)
  }
}
